import AxiosConfig from "./AxiosConfig";

const fetchWithFiltersLocal = (filters, url) => {
    return new Promise((resolve, reject) => {

        const storedData = JSON.parse(localStorage.getItem('seancesData'));
        if (storedData) {
            const foundSeances = storedData.filter(s => filters.includes(s.type));
            resolve(foundSeances);
        }
    });
};

const fetchWithSortLocal = (sort, url) => {
    return new Promise((resolve, reject) => {
        const storedData = JSON.parse(localStorage.getItem('seancesData'));
        if (storedData) {
            switch (sort) {
                case 'date':
                    storedData.sort((a, b) => {
                        return new Date(a.date) - new Date(b.date);
                    });
                    break;
                case 'dateDesc':
                    storedData.sort((a, b) => {
                        return new Date(b.date) - new Date(a.date);
                    });
                    break;
                case 'nom':
                    storedData.sort((a, b) => {
                        return a.titre.localeCompare(b.titre);
                    });
                    break;
                case 'nomDesc':
                    storedData.sort((a, b) => {
                        return  b.titre.localeCompare(a.titre);
                    });
                    break;
                default:
                    break;
            }
            resolve(storedData);
        } else {
            reject('Erreur lors de la récupération des données filtrées');
        }
    });
};

const fetchWithFiltersAndSort = (queryParams, url) => {
   const { filters, sort } = queryParams;

   const filterParamString = filters.join(',');

   return AxiosConfig.get(`${url}?sort=${sort}&filter=${filterParamString}`)
       .then(response => {
           return response.data;
       }).catch(error => {
           throw error;
       });
};

const applyFiltersAndSort = async (params, url, uriFilterName = "filter", uriSortName = "sort") => {
    const filterString = params.get(uriFilterName);
    const filters = filterString ? filterString.split(',') : [];

    const sort = params.get(uriSortName);

    try {
        const response = await fetchWithFiltersAndSort({filters, sort}, url);
        return response;

        // setSeances(response.seances.length > 0 ? response.seances : ["Aucune séance trouvée"]);
    } catch (error) {
        return error;
        // showModal('error', { children: "Une erreur est survenue lors de la récupération des séances", timeout: 1500 });
    }
}

const updateURLParams = (type, value, params, uriFilterName) => {
    switch (type) {
        case 'filter':
            if (value) {
                params.set(uriFilterName, value);
            } else {
                params.delete(uriFilterName);
            }
            break;
        case 'sort':
            params.set('sort', value);
            break;
        default:
            break;
    }

    return params;
    // navigate(`${location.pathname}?${params.toString()}`);
};

const handleFilterSubmit = (filters, uriFilterName = "filter") => {
    const filterValues = Object.entries(filters)
        .filter(([key, val]) => val)
        .map(([key]) => key)
        .join(',');

    updateURLParams(uriFilterName, filterValues);
};

const handleSortSubmit = (sort, params, uriFilterName = "filter") => {
    updateURLParams('sort', sort.sortOptions);
};

const updateFilterUri = (params, filterKey, filterValue, resetFilter = false) => {
    let existingFilters = params.get(filterKey);
    existingFilters = existingFilters ? existingFilters.split(',') : [];

    if (resetFilter) {
        if (existingFilters.includes(filterValue)) {
            existingFilters = existingFilters.filter(value => value !== filterValue);
        } else {
            existingFilters = [filterValue];
        }
    } else {
        if (existingFilters.includes(filterValue)) {
            existingFilters = existingFilters.filter(value => value !== filterValue);
        } else {
            existingFilters.push(filterValue);
        }
    }

    if (existingFilters.length > 0) {
        params.set(filterKey, existingFilters.join(','));
    } else {
        params.delete(filterKey);
    }
};


export { updateFilterUri, fetchWithFiltersLocal, fetchWithSortLocal, fetchWithFiltersAndSort, applyFiltersAndSort, handleFilterSubmit, handleSortSubmit, updateURLParams };